define(["data/config"], function(config) {
    require("vendor/jquery.payment");

    var prefix = config.prefixes.component;

    var highlightCard = function($iconCardWrap, card) {
        $iconCardWrap.removeClass(prefix + "iconCardWrap--empty");
        $iconCardWrap
            .find("." + prefix + "iconCardWrap-cardActive")
            .removeClass(prefix + "iconCardWrap-cardActive");
        if (!card) {
            $iconCardWrap.addClass(prefix + "iconCardWrap--empty");
        } else if (card === "visa" || card === "visaelectron") {
            $iconCardWrap
                .find("." + prefix + "iconCard--visa")
                .addClass(prefix + "iconCardWrap-cardActive");
        } else if (card === "mastercard" || card === "maestro") {
            $iconCardWrap
                .find("." + prefix + "iconCard--mc")
                .addClass(prefix + "iconCardWrap-cardActive");
        } else if (card === "amex") {
            $iconCardWrap
                .find("." + prefix + "iconCard--amex")
                .addClass(prefix + "iconCardWrap-cardActive");
        } else {
            $iconCardWrap
                .find("." + prefix + "iconCard--other")
                .addClass(prefix + "iconCardWrap-cardActive");
        }
    };

    var apply = function($element) {

        var form = document.getElementById('adyen-encrypted-form');
        var options = {};
        if($element.find('#adyen-encrypted-form-social-security-number').length) {
            var options = { "enableValidations": false };
        }
        adyen.encrypt.createEncryptedForm(form, adyen_cse_key, options);

        $element.on(config.events.buttonSwitchToggle, function(
            ev,
            $target,
            name
        ) {
            $element
                .find("." + prefix + "dialog--paymentDialog-surface")
                .hide();
            $element
                .find("." + prefix + "dialog--paymentDialog-surface--" + name)
                .show();
        });

        var $iconCardWrap = $element.find("." + prefix + "iconCardWrap");

        var $fields = {
            number: $element.find('input[x-autocompletetype="cc-number"]'),
            expMonth: $element.find('input[x-autocompletetype="cc-exp-month"]'),
            expYear: $element.find('input[x-autocompletetype="cc-exp-year"]'),
            csc: $element.find('input[x-autocompletetype="cc-csc"]'),
            socialSecurityNumber: $element.find('input[x-autocompletetype="cc-ssn"]'),
        };

        $fields.number.payment("formatCardNumber");
        $fields.csc.payment("formatCardCVC");
        $fields.number.on("keyup", function() {
            if ($.payment.validateCardNumber($(this).val())) {
                highlightCard($iconCardWrap, $.payment.cardType($(this).val()));
            } else {
                highlightCard($iconCardWrap, null);
            }
        });
        $fields.number.on("blur", function() {
            if ($.payment.validateCardNumber($(this).val())) {
                $fields.number.trigger(config.events.inputSuccess);
            } else if ($(this).val().length > 0) {
                $fields.number.trigger(config.events.inputError);
            }
        });
        $fields.csc.on("blur", function() {
            if ($.payment.validateCardCVC($(this).val(), $.payment.cardType())) {
                $fields.csc.trigger(config.events.inputSuccess);
            } else if ($(this).val().length > 0) {
                $fields.csc.trigger(config.events.inputError);
            }
        });
        $fields.expMonth.on("blur", function() {
            if ($fields.expYear.val() !== '') {
                if ($.payment.validateCardExpiry($(this).val(), $fields.expYear.val())) {
                    $fields.expYear.trigger(config.events.inputSuccess);
                    $fields.expMonth.trigger(config.events.inputSuccess);
                } else if ($(this).val().length > 0) {
                    $fields.expYear.trigger(config.events.inputError);
                    $fields.expMonth.trigger(config.events.inputError);
                }
            }
        });
        $fields.expYear.on("blur", function() {
            if ($fields.expMonth.val() !== '') {
                if ($.payment.validateCardExpiry($fields.expMonth.val(), $(this).val())) {
                    $fields.expYear.trigger(config.events.inputSuccess);
                    $fields.expMonth.trigger(config.events.inputSuccess);
                } else if ($(this).val().length > 0) {
                    $fields.expYear.trigger(config.events.inputError);
                    $fields.expMonth.trigger(config.events.inputError);
                }
            }
        });
        $fields.socialSecurityNumber.on("blur", function() {
            if ($.payment.validateCardSSN($(this).val())) {
                $fields.socialSecurityNumber.trigger(config.events.inputSuccess);
            } else if ($(this).val().length > 0) {
                $fields.socialSecurityNumber.trigger(config.events.inputError);
            }
        });
    };

    return {
        name: "dialog--paymentDialog",
        apply: apply
    };
});
